import React from 'react';
import classes from './notificationBell.module.scss';

interface NotificationBellProps {
  unreadCount: number;
  onClick: () => void;
  className?: string;
}

const NotificationBell: React.FC<NotificationBellProps> = ({
  unreadCount,
  onClick,
  className = '',
}) => {
  return (
    <div
      className={`${classes.notificationBell} ${className}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
      aria-label={`Notifications${unreadCount > 0 ? ` (${unreadCount} unread)` : ''}`}
    >
      <i className="pi pi-bell" />
      {unreadCount > 0 && (
        <span className={classes.badge} aria-label={`${unreadCount} unread notifications`}>
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </div>
  );
};

export default NotificationBell;
